export default __webpack_public_path__ + "static/media/ende schiessuebungsstrecke.27c37067.png";